
import React from 'react'

class EmptyWidgetMsg extends React.Component {
  render () {
    return null
  }
}

export default EmptyWidgetMsg



// WEBPACK FOOTER //
// ./src/js/components/Widget/EmptyWidgetMsg.js